<template>
  <div class="elasticsearchMonitorSearch">
    <Row :gutter="4">
      <!-- 选择公司 -->
      <div v-if="company == 1">
        <Col span="4">
          <Select
            v-model="companyId"
            filterable
            :placeholder="$t('alarms.common.pleaseSelectCompany')"
            :transfer="true"
          >
            <Option value=" " selected>{{ $t("alarms.common.all") }}</Option>
            <Option
              :value="item.id"
              v-for="item in companyList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </Col>
      </div>
      <Col span="4">
        <Input
          v-model="esName"
          :placeholder="$t('alarms.elasticSearch.filterByEsDomainName')"
        />
      </Col>
      <Col span="4">
        <!-- v-on:input实时查询 -->
        <Input
          v-model="tag"
          :placeholder="$t('alarms.common.filterByTagKey')"
        />
      </Col>
      <Col span="4">
        <Button
          type="primary"
          v-hasPermission="['monitor:elasticsearchMonitor:page']"
          @click="getData"
          >{{ $t("message.select") }}</Button
        >
      </Col>
    </Row>
  </div>
</template>
<script>
import TableElasticsearch from "../es/TableElasticsearch";
import { setCookie, getCookie } from "../../../utils/cookieUtil.js";
var tableElasticsearch = TableElasticsearch;
export default {
  name: "ElasticsearchMonitorSearch",
  data() {
    return {
      tag: "",
      company: getCookie(global.companyId),
      companyId: "",
      companyList: [],
      stateSearchKey: [],
      esName: ""
    };
  },
  mounted: function() {
    if (this.company == 1) {
      this.getCompanyDropDownBox();
    }
  },
  methods: {
    getData() {
      eventBus.$emit("companyId", this.companyId);
      eventBus.$emit("esName", this.esName);
      eventBus.$emit("tag", this.tag);
      tableElasticsearch.methods.showAll();
    },
    // 获取公司下拉框
    getCompanyDropDownBox: function() {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.companyList = res.data;
        });
    }
  }
};
</script>
<style scoped>
.elasticsearchMonitorSearch {
  height: 51px;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/es/ElasticsearchMonitorSearch.vue